<div class="header">
  <div class="title">{{ property?.name || property.address?.address_string }}</div>
  <div>
    <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
</div>

<mat-tab-group preserveContent>
  <mat-tab label="Demographics">
    <ng-container *ngIf="aggregateMarketDemographics && !demographicsLoading; else NoDemographicsDataOrLoading">
      <div class="flex flex-col bg-card overflow-hidden">
        <div class="flex flex-col">
          <table class="w-full bg-transparent">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">
                  <mat-form-field class="field treo-mat-no-subscript">
                    <mat-select
                      [(ngModel)]="marketDataDistanceType"
                      (selectionChange)="onChangeDemographicDistancType()"
                    >
                      <mat-option [value]="'MILES'">Miles (1,3,5)</mat-option>
                      <mat-option [value]="'MINUTES'">Drive-Time (10,20,30)</mat-option>
                    </mat-select>
                  </mat-form-field>
                </th>
                <th
                  class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                  *ngFor="let mileage of demographicDistanceRadius[demographicDistanceType]"
                >
                  {{ mileage }} {{ marketDataDistanceType === 'MILES' ? 'Miles' : 'Minutes' }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Total Population</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.population | number: '1.0-0' }}
                    <span class="priority text-sm">
                      (<span *ngIf="row.populationChgPct_2020 < 0">-</span>

                      <!-- High -->
                      <span *ngIf="row.populationChgPct_2020 > 0">+</span>
                      {{ row.populationChgPct_2020 | percent: '1.0' }})
                    </span>
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Total Households</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.households | number: '1.0-0' }}
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Med. Household Income</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.medianHouseholdIncome | tsCurrency: 'USD' : 'symbol' : '1.2-2' }}
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Med. Housing Value</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.medianHouseholdValue | tsCurrency: 'USD' : 'symbol' : '1.2-2' }}
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Total Housing Units</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.housingUnits | number: '1.0-0' }}
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Renter Occupied Housing Units</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.housingUnitsRenterOccupied | number: '1.0-0' }}
                    <span class="text-sm">({{ row.housingUnitsRenterOccupiedPct | percent: '1.0' }})</span>
                  </td>
                </ng-container>
              </tr>
              <tr class="mat-row cdk-row order-row h-16">
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title">Vacant Housing Units</td>
                <ng-container *ngFor="let row of aggregateMarketDemographics['distances']">
                  <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                    {{ row.housingUnitsVacant | number: '1.0-0' }}
                    <span class="text-sm">({{ row.housingUnitsVacantPct | percent: '1.0' }})</span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </mat-tab>

  <mat-tab label="Schools">
    <ng-container *ngIf="parcelData?.schools; else NoData">
      <table class="w-full bg-transparent">
        <thead>
          <tr class="mat-header-row">
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t"></th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Name</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Type</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">District</th>
          </tr>
        </thead>
        <tbody>
          <tr class="mat-row cdk-row order-row h-16" *ngFor="let school of parcelData.schools">
            <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
              <span
                class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
                [ngClass]="[
                  school?.schoolRating?.includes('A') ? 'green-100' : '',
                  school?.schoolRating?.includes('B') ? 'green-100' : '',
                  school?.schoolRating?.includes('C') ? 'orange-100' : '',
                  school?.schoolRating?.includes('D') ? 'red-300' : '',
                  school?.schoolRating?.includes('E') ? 'red-300' : '',
                  school?.schoolRating?.includes('F') ? 'red-300' : '',
                ]"
              >
                <span class="leading-relaxed whitespace-nowrap">{{ school?.schoolRating }}</span>
              </span>
            </td>
            <td class="mat-cell cdk-cell cdk-column-title mat-column-title">{{ school?.schoolNm }}</td>
            <td class="mat-cell cdk-cell cdk-column-title mat-column-title">{{ school?.instructionalLevel }}</td>
            <td class="mat-cell cdk-cell cdk-column-title mat-column-title">{{ school?.schoolDistrictNm }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </mat-tab>

  <ng-template #NoDemographicsDataOrLoading>
    <ng-container *ngIf="!aggregateMarketDemographics && !demographicsLoading; else Loading">
      <p class="py-16 font-bold text-md text-secondary uppercase tracking-wider text-center p-4">No data to display</p>
    </ng-container>
  </ng-template>

  <ng-template #Loading>
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-template>

  <ng-template #NoData>
    <p class="py-16 font-bold text-md text-secondary uppercase tracking-wider text-center p-4">No data to display</p>
  </ng-template>

  <ng-template #NoGraph>
    <p class="py-16 font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
      Insufficient data to display graph
    </p>
  </ng-template>
</mat-tab-group>
